export default "__VITE_ASSET__eU7CJFIXHKHc1T1eVB7ANA__"